<template>
  <div class="page">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data: function () {
    return {}
  },
  mounted: function () {

  },
  methods: {}
}
</script>

<style scoped>

</style>
